import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { Container } from '@optimus-web/core';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/ReservationContracts/Template')({
    component: () => (
        <Container padding={['200', '400']}>
            <Outlet />
        </Container>
    ),
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
    },
});
